var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.793 9.425a.5.5 0 01-.38.825H4.587a.5.5 0 01-.38-.825L7.62 5.443a.5.5 0 01.76 0l3.412 3.982z",
    fill: "#8D92A1"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjc5MjUgOS40MjQ2QzEyLjA3MDUgOS43NDg5NCAxMS44NDAxIDEwLjI1IDExLjQxMjkgMTAuMjVMNC41ODcxMSAxMC4yNUM0LjE1OTkzIDEwLjI1IDMuOTI5NDggOS43NDg5NCA0LjIwNzQ4IDkuNDI0Nkw3LjYyMDM3IDUuNDQyOUM3LjgxOTkyIDUuMjEwMDkgOC4xODAwOCA1LjIxMDA5IDguMzc5NjMgNS40NDI5TDExLjc5MjUgOS40MjQ2WiIgZmlsbD0iIzhEOTJBMSIvPgo8L3N2Zz4K";
export { SvgUpArrow as ReactComponent };